export type EstimationMethodVo =
  | '原価積み上げ式'
  | '荷主価格式-距離制'
  | '荷主価格式-時間制'
  | '荷主価格式-個建て'
  | '荷主価格式-厳密計算'
  | '荷主価格式-厳密計算-荷主別'

export const estimationMethods: EstimationMethodVo[] = [
  '原価積み上げ式',
  '荷主価格式-距離制',
  '荷主価格式-時間制',
  '荷主価格式-個建て',
  '荷主価格式-厳密計算',
  '荷主価格式-厳密計算-荷主別',
];
